import React from 'react';

export type CompleteMarker = {
  completed: boolean;
};

export function CompleteMarker({ completed }: CompleteMarker) {
  return <div className={`complete-marker ${completed ? 'checked' : ''}`} aria-checked={completed}></div>;
}
